import { Col, Form, Modal } from "react-bootstrap";
// import "./Modal.scss";
import FloatingInput from "../compoment/ui/FloatingInput";
import Email from "../compoment/icon/Email";
import LogoBlack from './../assets/img/MOSIDA-black.png'
import { FormEvent, useState } from "react";
import { useForm } from "../constants/useForm";
import { toast } from "react-toastify";
import EyeOpen from "../compoment/icon/EyeOpen";

interface SigninModalProps {
  show: boolean;
  onHide: () => void;
  props?: Record<string, unknown>;
  setSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSigninModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const SuccessModal: React.FC<SigninModalProps> = ({
  show,
  onHide,
  props,
  setSigninModal,
  setSuccessModal
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { values, handleChange } = useForm({
    email: "",
  });

  const handleSubmit = () => {
    setSigninModal(true);

  };

  return (
    <>
      <Modal
        className="mosidaModal signinModal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
      >
        <Modal.Header className="pb-0" closeButton></Modal.Header>
        <Modal.Body className="py-5">
          <Col md={10} className="mx-auto">
            <div className="text-center mb-5 pb-md-2 mt-5">
              <img
                className="pointer"
                style={{ width: 140 }}
                src={LogoBlack}
                alt=""
              />
            </div>

            <div className="sectionHeading text-center mb-2 pb-3">
              Password Changed!
            </div>
            <p className="text-muted text-center mb-4 pb-3">{`Your password has been changed successfully.`}</p>
            <button
              className="btnPrimary w-100 sqaure"
              type="submit"
              onClick={handleSubmit}
            >
              Continue
            </button>

            {/* <div className="dontHaveAccount mt-4">
              {`Don’t have an account?`}{" "}
              <span
                className="text-primary"
                onClick={() => {
                  setForgotPasswordModal(false);
                  setSignupModal(true);
                }}
              >
                Sign up
              </span>
            </div> */}
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SuccessModal;


